<template>
  <transition name="fade">
    <div>
      <div class="pop-up-bg" @click.prevent="$emit('close', false)"></div>
      <div class="pop-up pop-up--delete">
        <a class="pop-up__close icon icon-close" @click.prevent="$emit('close', false)"></a>
        <h2>#{{list.index + 1}}</h2>
        <div class="block-list">

          <div v-show="list.mod == 'delete'">
            <div class="img warning"></div>
            <h3>{{$root.langText.isDelete}}</h3>
          </div>
          <div v-show="list.mod == 'copy'">
            <div class="img copy"></div>
            <h3>{{$root.langText.isCopying}}</h3>
          </div>
          <div v-show="list.mod !== 'copy' && list.mod !== 'delete'">


            <!-- auto -->
            <div v-if="list.name.mode == 'auto'">

              <div class="form__input">
                <the-mask style="text-transform: uppercase;" type="text" v-model="auto.vin" :mask="['XXXXXXXXXXXXXXXXX']"></the-mask>
                <span>{{$root.langText.input.vin}}</span>
              </div>

              <Autocomplete 
                :data="{name: $root.langText.input.brand, mod: 'all', modType: 'carManufacturers', key: 'brand', input: auto.brand, inputId: auto.brand_id}" 
                @result="autocompleteResult" 
              />


              <div class="form__row form__row-50">
                <Autocomplete 
                  :data="{name: $root.langText.input.model, mod: 'all', modType: 'carModels', key: 'model', input: auto.model, inputId: auto.model_id}" 
                  @result="autocompleteResult" 
                />


                <div class="form__input">
                  <input 
                    type="text" 
                    v-model="auto.year"
                  >
                  <span>{{$root.langText.input.carYear2}}</span>
                </div>
              </div>

              <DataInput  :data="{data: auto.dateIssue, input: 'dateIssue', name: $root.langText.input.dateIssueCar}" @resultData="dataInput"/>
              
              <DataInput  :data="{data: auto.dateDisbandment, input: 'dateDisbandment', name: $root.langText.input.dateDisbandment}" @resultData="dataInput"/>


              <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="text" 
                    v-model="auto.invoiceAmount"
                  >
                  <span>{{$root.langText.input.invoiceAmount}}</span>
                </div>
                
                <div class="form__input">
                  <input 
                    type="text" 
                    v-model="auto.officialPayments"
                  >
                  <span>{{$root.langText.input.amountOfficialPayments}}</span>
                </div>

              </div>


            </div>


            <!-- containers -->
            <div v-if="list.name.mode == 'containers'">
              <div class="form__input">
                <the-mask style="text-transform: uppercase;" type="text" v-model="containers.number" :mask="['XXXX#######', '###########']"></the-mask>
                
                <span>№ {{$root.langText.input.container}}</span>
              </div>


              <div class="form__row form__row-50">
                <Autocomplete 
                  :data="{name: $root.langText.input.type, mod: 'carType', key: 'carType', input: containers.carType, inputId: containers.carType_id}" 
                  @result="autocompleteResult" 
                />
                <div class="form__input">
                  <input 
                    type="number" 
                    v-model="containers.weight"
                  >
                  <span>{{$root.langText.input.weight}}</span>
                </div>
              </div>


              <div class="form__row form__row-50">
                <DataInput  :data="{data: containers.exit, input: 'exit', name: $root.langText.input.departure}" @resultData="dataInput"/>
                <DataInput  :data="{data: containers.return, input: 'return', name: $root.langText.input.return}" @resultData="dataInput"/>
              </div>


              <div class="form__row form__row-50">
                <DataInput  :data="{data: containers.atClient, input: 'atClient', name: $root.langText.input.atClient}" @resultData="dataInput"/>
                <DataInput  :data="{data: containers.fromClient, input: 'fromClient', name: $root.langText.input.fromClient}" @resultData="dataInput"/>
              </div>



              <Autocomplete 
                :data="{name: '№ ' + $root.langText.input.auto, mod: 'all', modType: 'car', key: 'car', input: containers.car, inputId: containers.car_id}" 
                @result="autocompleteResult" 
              />


              <Autocomplete 
                :data="{name: $root.langText.input.trailer, mod: 'trailers', key: 'trailers', input: containers.trailers, inputId: containers.trailers_id}" 
                @result="autocompleteResult" 
              />


              <Autocomplete 
                :data="{name: $root.langText.input.driver, mod: 'drivers', key: 'driver', input: containers.driver, inputId: containers.driver_id}" 
                @result="autocompleteResult" 
              />

              <div class="form__input">
                <input 
                  type="tel" readonly
                  v-model="containers.driver_phone"
                >
                <span>{{$root.langText.input.phone}}</span>
              </div>

              <div class="form__input">
                <input 
                  type="text" 
                  v-model="containers.position"
                >
                <span>{{$root.langText.input.location}}</span>
              </div>


            </div>



            <!-- services -->
            <div v-if="list.name.mode == 'services'">

              <Autocomplete 
                :data="{name: $root.langText.input.name2, mod: 'all', modType: 'servicesName', key: 'name', input: services.name, inputId: services.name_id}" 
                @result="autocompleteResult" 
              />

              <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="number" 
                    @input="changeInput('income')"
                    v-model="services.amount"
                  >
                  <span>{{$root.langText.input.quantity}}</span>
                </div>

                <div class="form__checkbox" style="width: 100%">
                  <label>
                    <input 
                      type="checkbox"
                      v-model="services.isIncomeRateNDS"
                    >
                    <span style="font-size: 14px !important">{{$root.langText.input.incomeRateNdsNot}}</span>
                  </label>
                </div>
              </div>


              <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="number" 
                    @input="changeInput('income')"
                    v-model="services.rateIncome"
                  >
                  <span>{{$root.langText.input.rateReturn}}</span>
                </div>
                

                <Autocomplete 
                  :data="{name: $root.langText.input.ndsIncome, mod: 'all', modType: 'incomeNDS', key: 'incomeNDS', input: services.incomeNDS, inputId: services.incomeNDS_id}" 
                  @result="autocompleteResult" 
                />
              </div>



              <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="text" readonly
                    v-model="services.income"
                  >
                  <span>{{$root.langText.input.income}}</span>
                </div>
                

                <div class="form__input">
                  <select 
                    v-model="services.incomeCurrency"
                    @change="changeCurrency('income')"
                    >
                    <option
                      v-for="(item, index) in currency"
                      :key="index"
                    :value="item.id">{{item.name}}</option>
                    
                  </select>
                  <span>{{$root.langText.input.currencyIncome}}</span>
                  <div class="icon icon-arrow-down"></div>
                </div>
              </div>



              <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="text" 
                    @input="changeInput('income')"
                    v-model="services.incomeCourse"
                  >
                  <span>{{$root.langText.input.incomeRate}}</span>
                </div>
                

                <div class="form__input">
                  <input 
                    type="text" readonly
                    v-model="services.incomeYe"
                  >
                  <span>{{$root.langText.input.incomeYe}}</span>
                </div>
              </div>


              <Autocomplete 
                :data="{name: $root.langText.input.incomePaymentType, mod: 'all', modType: 'paymentTypes', key: 'incomePaymentType', input: services.incomePaymentType, inputId: services.incomePaymentType_id}" 
                @result="autocompleteResult" 
              />


              <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="text" 
                    v-model="services.expenseRate"
                    @input="changeInput('expense')"
                  >
                  <span>{{$root.langText.input.expenseRate}}</span>
                </div>

                <div class="form__checkbox" style="width: 100%">
                  <label>
                    <input 
                      type="checkbox"
                      v-model="services.isExpenseRateNDS"
                    >
                    <span style="font-size: 14px !important">{{$root.langText.input.expenseRateNdsNot}}</span>
                  </label>
                </div>
              </div>


              <div class="form__input">
                <input 
                  type="text" 
                  v-model="services.expenseNDS"
                >
                <span>{{$root.langText.input.ndsExpense}}</span>
              </div>


              <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="text" readonly
                    v-model="services.expense"
                  >
                  <span>{{$root.langText.input.expense}}</span>
                </div>
                

                <div class="form__input">
                  <select 
                    v-model="services.expenseCurrency"
                    @change="changeCurrency('expense')">
                    <option
                      v-for="(item, index) in currency"
                      :key="index"
                    :value="item.id">{{item.name}}</option>
                    
                  </select>
                  <span>{{$root.langText.input.currencyExpense}}</span>
                  <div class="icon icon-arrow-down"></div>
                </div>
              </div>


              <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="text" 
                    @input="changeInput('expense')"
                    v-model="services.expenseCourse"
                  >
                  <span>{{$root.langText.input.expenseRate2}}</span>
                </div>
                

                <div class="form__input">
                  <input 
                    type="text" readonly
                    v-model="services.expenseYe"
                  >
                  <span>{{$root.langText.input.expenseYe}}</span>
                </div>
              </div>


              <Autocomplete 
                :data="{name: $root.langText.input.expensePaymentType, mod: 'all', modType: 'paymentTypes', key: 'expensePaymentType', input: services.expensePaymentType, inputId: services.expensePaymentType_id}" 
                @result="autocompleteResult" 
              />

              <DataInput  :data="{data: services.datePayment, input: 'datePayment', name: $root.langText.input.paymentDate}" @resultData="dataInput"/>

              <Autocomplete 
                :data="{name: $root.langText.input.provider, mod: 'counterparties', key: 'provider', input: services.provider, inputId: services.provider_id}" 
                @result="autocompleteResult" 
              />

              <div class="form__input">
                <input 
                  type="text" 
                  v-model="services.note"
                >
                <span>{{$root.langText.input.note}}</span>
              </div>


              <!-- <div class="form__row form__row-50">
                <div class="form__input">
                  <input 
                    type="text" 
                    v-model="services.prefix"
                  >
                  <span>Префикс</span>
                </div>
                

                <div class="form__input">
                  <input 
                    type="number" 
                    v-model="services.number"
                  >
                  <span>Номер</span>
                </div>
              </div> -->


            </div>




          </div>
        </div>
        <div class="block-btn" v-if="list.mod == 'copy'">
          <a class="btn btn-primary" @click.prevent="save()">{{$root.langText.copy}}</a>
          <a class="btn btn-secondary" @click.prevent="$emit('close', false)">{{$root.langText.delete}}</a>
        </div>

        <div class="block-btn block-btn--color" v-else-if="list.mod == 'delete'">
          <a class="btn btn-primary" @click.prevent="removeList()">{{$root.langText.delete}}</a>
          <a class="btn btn-secondary" @click.prevent="$emit('close', false)">{{$root.langText.keep}}</a>
        </div>

        <div class="pop-up__btn pop-up__btn--one" v-else>
          <div v-if="list.canEdit">
            <a class="btn btn-primary" @click.prevent="save()">{{$root.langText.save}}</a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



<style lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to{
    opacity: 0;
  }
  .warning{
    background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 511.999 511.999' style='enable-background:new 0 0 511.999 511.999;' xml:space='preserve'%3E%3Cpath style='fill:%23E50027;' d='M501.449,368.914L320.566,66.207C306.751,43.384,282.728,29.569,256,29.569 s-50.752,13.815-64.567,36.638L10.55,368.914c-13.812,23.725-14.113,51.954-0.599,75.678c13.513,23.723,37.836,37.838,65.165,37.838 h361.766c27.329,0,51.653-14.115,65.165-37.838C515.563,420.868,515.262,392.639,501.449,368.914z'/%3E%3Cpath style='fill:%23C1001F;' d='M502.049,444.592c-13.513,23.723-37.836,37.838-65.165,37.838H256V29.57 c26.727,0,50.752,13.815,64.567,36.638L501.45,368.915C515.262,392.639,515.563,420.868,502.049,444.592z'/%3E%3Cpath style='fill:%23FD003A;' d='M75.109,452.4c-16.628,0-30.851-8.27-39.063-22.669c-8.211-14.414-8.065-31.087,0.469-45.72 L217.23,81.549c8.27-13.666,22.816-21.951,38.769-21.951s30.5,8.284,38.887,22.157l180.745,302.49 c8.388,14.4,8.534,31.072,0.322,45.485c-8.211,14.4-22.435,22.669-39.063,22.669H75.109V452.4z'/%3E%3Cpath style='fill:%23E50027;' d='M436.891,452.4c16.628,0,30.851-8.27,39.063-22.669c8.211-14.414,8.065-31.087-0.322-45.485 L294.886,81.754c-8.388-13.871-22.933-22.157-38.887-22.157V452.4H436.891z'/%3E%3Cpath style='fill:%23E1E4FB;' d='M286.03,152.095v120.122c0,16.517-13.514,30.03-30.03,30.03s-30.031-13.514-30.031-30.03V152.095 c0-16.517,13.514-30.031,30.031-30.031S286.03,135.578,286.03,152.095z'/%3E%3Cpath style='fill:%23C5C9F7;' d='M286.03,152.095v120.122c0,16.517-13.514,30.03-30.03,30.03V122.064 C272.516,122.064,286.03,135.578,286.03,152.095z'/%3E%3Cpath style='fill:%23E1E4FB;' d='M256,332.278c-24.926,0-45.046,20.119-45.046,45.046c0,24.924,20.119,45.046,45.046,45.046 s45.046-20.121,45.046-45.046C301.046,352.398,280.925,332.278,256,332.278z'/%3E%3Cpath style='fill:%23C5C9F7;' d='M301.046,377.323c0,24.924-20.119,45.046-45.046,45.046v-90.091 C280.925,332.278,301.046,352.398,301.046,377.323z'/%3E%3C/svg%3E%0A");
    width: 60px;
    height: 60px;
    margin: 0 auto 20px;
  }
  .copy{
    width: 60px;
    height: 60px;
    margin: 0 auto 20px;
    background-image: url("data:image/svg+xml,%0A%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512;' xml:space='preserve'%3E%3Cpath style='fill:%23FA6E51;' d='M0,256.006C0,397.402,114.606,512.004,255.996,512C397.394,512.004,512,397.402,512,256.006 C512.009,114.61,397.394,0,255.996,0C114.606,0,0,114.614,0,256.006z'/%3E%3Cpath style='fill:%23E8573F;' d='M511.393,272.788l-119.43-119.43h-0.001l-61.725-61.725c-0.634-0.636-1.394-1.142-2.235-1.494 c-0.837-0.35-1.743-0.539-2.669-0.539h-124.8c-3.828,0-6.933,3.105-6.933,6.933V131.2h-76.267c-3.828,0-6.933,3.104-6.933,6.933 v277.333c0,2.347,1.243,4.32,3.027,5.574c0.463,0.658,82.754,82.949,83.412,83.412c0.217,0.309,0.526,0.521,0.783,0.783 c18.758,4.377,38.282,6.765,58.373,6.764C391.75,512.004,502.742,406.351,511.393,272.788z'/%3E%3Cpath style='fill:%23F4F6F9;' d='M401.061,163.197c-0.352-0.842-0.859-1.6-1.494-2.235l-69.329-69.329 c-0.635-0.635-1.393-1.142-2.235-1.494c-0.838-0.35-1.744-0.539-2.67-0.539h-124.8c-3.829,0-6.933,3.104-6.933,6.933V131.2h-76.267 c-3.829,0-6.933,3.104-6.933,6.933v277.333c0,3.829,3.104,6.933,6.933,6.933h194.133c3.829,0,6.933-3.104,6.933-6.933V380.8h76.267 c3.829,0,6.933-3.104,6.933-6.933v-208C401.6,164.941,401.411,164.035,401.061,163.197z M332.267,113.27l45.663,45.663h-45.663 V113.27z M304.533,408.533H124.267V145.067H235.2v62.4c0,3.829,3.104,6.933,6.933,6.933h62.4V408.533z M294.73,200.533h-45.663 V154.87L294.73,200.533z M318.4,366.933V207.467c0-0.926-0.189-1.831-0.539-2.67c-0.352-0.842-0.859-1.6-1.494-2.235l-69.329-69.329 c-0.635-0.635-1.393-1.142-2.235-1.494c-0.838-0.35-1.744-0.539-2.67-0.539h-34.667v-27.733H318.4v62.4 c0,3.829,3.104,6.933,6.933,6.933h62.4v194.133H318.4z'/%3E%3C/svg%3E%0A");
  }
</style>



<script>
import Autocomplete from "@/components/app/Autocomplete"
import DataInput from '@/components/app/DataInput'
import {TheMask} from 'vue-the-mask'


export default {
  props: ['list'],

  data: () => ({


    auto: {
      vin: '',
      brand: '',
      brand_id: '',
      model: '',
      model_id: '',
      year: '',
      dateIssue: '',
      dateDisbandment: '',
      invoiceAmount: '',
      officialPayments: '',
    },

    containers: {
      number: '',
      carType: '',
      carType_id: '',
      exit: '',
      return: '',
      atClient: '',
      fromClient: '',
      weight: '',
      car: '',
      car_id: '',
      trailers: '',
      trailers_id: '',
      driver: '',
      driver_id: '',
      driver_phone: '',
      position: ''
    },

    services: {
      name: '',
      name_id: '',
      amount: 1,

      isIncomeRateNDS: '',
      rateIncome: '',
      incomeNDS: '',
      incomeNDS_id: '',
      income: '',
      incomeCurrency: '4',
      incomeCourse: '',
      incomeYe: '',
      incomePaymentType: '',
      incomePaymentType_id: '',

      expenseRate: '',
      isExpenseRateNDS: '',
      expenseNDS: '',
      expenseNDS_id: '',
      expense: '',
      expenseCurrency: '4',
      expenseCourse: '',
      expenseYe: '',
      expensePaymentType: '',
      expensePaymentType_id: '',
      
      datePayment: '',
      provider: '',
      provider_id: '',
      note: '',
      prefix: '',
      number: '',
    },


    currencyIcc: '1',
    currency: [],
    masked: true,
    //select
    params: {
      start: 0, 
      limit: 50,
    },
  }),



  async created() {
    function boolean(val){
      return (val == 0) ? (false) : true
    }
    //base Currency
    const currency = await this.$store.dispatch('getCurrency', this.params);
    this.currency = currency.data.list;
    var app = this
    this.currency.forEach(function(item, index){
      if(app.list.mod == 'create'){
        if(item.id == '4'){
          app.services.incomeCourse = item.exchange_rate
          app.services.expenseCourse = item.exchange_rate
        }
      } else if(app.services.incomeCourse == 0){
        if(app.services.incomeCurrency == item.id){
          app.services.incomeCourse = item.exchange_rate
        }
      } else if(app.services.expenseCourse == 0){
        if(app.services.expenseCurrency == item.id){
          app.services.expenseCourse = item.exchange_rate
        }
      }

      if(item.is_default == 1){
        app.currencyIcc = item.exchange_rate;
      }

    })

    //info
    if(this.list.name.mode == 'auto'){
      if(this.list.mod == 'update' || this.list.mod == 'copy'){
        this.auto.brand = this.list.lists[this.list.index].car_manufacture_name
        this.auto.brand_id = this.list.lists[this.list.index].car_manufacture
        this.auto.model = this.list.lists[this.list.index].car_model_name
        this.auto.model_id = this.list.lists[this.list.index].car_model
        this.auto.year = this.list.lists[this.list.index].release_year
        this.auto.dateIssue = this.list.lists[this.list.index].date_issue
        this.auto.dateDisbandment = this.list.lists[this.list.index].date_disbandment
        this.auto.invoiceAmount = this.list.lists[this.list.index].sum_calc
        this.auto.officialPayments = this.list.lists[this.list.index].sum_off_payments
      }
      if(this.list.mod == 'update'){
        this.auto.vin = this.list.lists[this.list.index].vin_code
      }
    }

    if(this.list.name.mode == 'containers'){
      if(this.list.mod == 'update' || this.list.mod == 'copy'){
        

        this.containers.carType = this.list.lists[this.list.index].type_name
        this.containers.carType_id = this.list.lists[this.list.index].type

        this.containers.exit = this.list.lists[this.list.index].date1
        this.containers.return = this.list.lists[this.list.index].date2
        this.containers.atClient = this.list.lists[this.list.index].atClient
        this.containers.fromClient = this.list.lists[this.list.index].fromClient

        this.containers.weight = this.list.lists[this.list.index].weight

        this.containers.car = this.list.lists[this.list.index].truck
        this.containers.car_id = this.list.lists[this.list.index].truck_id

        this.containers.trailers = this.list.lists[this.list.index].trailer
        this.containers.trailers_id = this.list.lists[this.list.index].trailer_id

        this.containers.driver = this.list.lists[this.list.index].driver
        this.containers.driver_id = this.list.lists[this.list.index].driver_id
        
        this.containers.driver_phone = this.list.lists[this.list.index].phone
        this.containers.position = this.list.lists[this.list.index].positionText
      }
      if(this.list.mod == 'update'){
        this.containers.number = this.list.lists[this.list.index].number
      }
    }


    if(this.list.name.mode == 'services'){
      if(this.list.mod == 'update' || this.list.mod == 'copy'){
        this.services.name = this.list.lists[this.list.index].service_name
        this.services.name_id = this.list.lists[this.list.index].service_id
        this.services.amount = this.list.lists[this.list.index].num

        this.services.isIncomeRateNDS = boolean(this.list.lists[this.list.index].rate_in_without_vat)
        this.services.rateIncome = this.list.lists[this.list.index].rate
        this.services.incomeNDS = this.list.lists[this.list.index].vat_income_name
        this.services.incomeNDS_id = this.list.lists[this.list.index].vat_income_id
        this.services.income = this.list.lists[this.list.index].sum_income
        this.services.incomeCurrency = this.list.lists[this.list.index].currency_income
        this.services.incomeCourse = this.list.lists[this.list.index].exchange_rate_in
        this.services.incomeYe = this.list.lists[this.list.index].sum_income2
        this.services.incomePaymentType = this.list.lists[this.list.index].payment_type_income_name
        this.services.incomePaymentType_id = this.list.lists[this.list.index].payment_type_income

        this.services.expenseRate = this.list.lists[this.list.index].rate_outgo
        this.services.isExpenseRateNDS = boolean(this.list.lists[this.list.index].rate_out_without_vat)
        this.services.expenseNDS = this.list.lists[this.list.index].vat_name
        this.services.expenseNDS_id = this.list.lists[this.list.index].vat_id
        if(this.list.lists[this.list.index].rate_outgo > 0 && this.list.lists[this.list.index].num > 0){
          this.services.expense = this.list.lists[this.list.index].rate_outgo * this.list.lists[this.list.index].num;
        } else{
          this.services.expense = '';
        }
        this.services.expenseCurrency = this.list.lists[this.list.index].currency_id
        this.services.expenseCourse = this.list.lists[this.list.index].exchange_rate_out
        this.services.expenseYe = this.list.lists[this.list.index].sum_outgo2
        this.services.expensePaymentType = this.list.lists[this.list.index].payment_type_name
        this.services.expensePaymentType_id = this.list.lists[this.list.index].payment_type

        this.services.datePayment = this.list.lists[this.list.index].payment_date
        // this.services.provider = this.list.lists[this.list.index].contractor_id
        this.services.provider_id = this.list.lists[this.list.index].contractor_id
        this.services.note = this.list.lists[this.list.index].comment
        this.services.prefix = this.list.lists[this.list.index].cont_pref
        this.services.number = this.list.lists[this.list.index].cont_numbers
      }
      this.changeCurrency('income');
      this.changeCurrency('expense');
    }
      
  },


  methods: {

    changeCurrency(data){
      var app = this;
      if(data == 'income'){
        if(this.list.modCreate == 'order'){
          this.currency.forEach(function(item, index){
            if(app.services.incomeCurrency == item.id){
              app.services.incomeCourse = item.exchange_rate;
            }
          });
          if(this.services.income == 0 || this.services.income == ''){
            this.services.incomeYe = 0
          } else{
            if (this.currency[0].is_reversed == 0) {
              this.services.incomeYe = (+this.services.income / +this.services.incomeCourse * this.currencyIcc).toFixed(2);
            } else{
              
              this.services.incomeYe = (+this.services.income * +this.services.incomeCourse / this.currencyIcc).toFixed(2);
            }
          }
        } else{
          var currencyReal;
          var currencyTotal = 1;
          var is_reversed = 0;
          var sum = +this.services.income;
     
          this.currency.forEach(function(item, index){
            if(item.id == app.list.total_sums_currency_id){
              currencyTotal = item.exchange_rate;
            }
            if(item.id == app.services.incomeCurrency){
              currencyReal = item.exchange_rate;
            }
            if(item.is_reversed == 1){
              is_reversed = 1
            }
          });

          if(this.services.income == 0 || this.services.income == ''){
            this.services.incomeYe = 0
          } else{

            if (is_reversed == "0") {
              this.services.incomeYe = (sum / currencyReal * currencyTotal).toFixed(2);
            } else{
              this.services.incomeYe = (sum * currencyReal / currencyTotal).toFixed(2);
            }
            this.services.incomeCourse = currencyReal
          }

        }
      } else{

        if(this.list.modCreate == 'order'){
          this.currency.forEach(function(item, index){
            if(app.services.expenseCurrency == item.id){
              app.services.expenseCourse = item.exchange_rate;
            }
          });
          if(this.services.expense == 0 || this.services.expense == ''){
            this.services.expenseYe = 0
          } else{
            if (this.currency[0].is_reversed == 0) {
              this.services.expenseYe = (+this.services.expense / +this.services.expenseCourse * this.currencyIcc).toFixed(2);
            } else{
              this.services.expenseYe = (+this.services.expense * +this.services.expenseCourse / this.currencyIcc).toFixed(2);
            }
          }
        } else{
          var currencyReal;
          var currencyTotal = 1;
          var is_reversed = 0;
          var sum = +this.services.expense;

          this.currency.forEach(function(item, index){
            if(item.id == app.list.total_sums_currency_id){
              currencyTotal = item.exchange_rate;
            }
            if(item.id == app.services.expenseCurrency){
              currencyReal = item.exchange_rate;
            }
            if(item.is_reversed == 1){
              is_reversed = 1
            }
          });

          if(this.services.income == 0 || this.services.income == ''){
            this.services.expenseYe = 0
          } else{
            if (is_reversed == "0") {
              this.services.expenseYe = (sum / currencyReal * currencyTotal).toFixed(2);
            } else{
              this.services.expenseYe = (sum * currencyReal / currencyTotal).toFixed(2);
            }
            this.services.expenseCourse = currencyReal
          }
        }
      }
    },
    changeInput(data){
      this.services.income = +this.services.rateIncome * +this.services.amount
      this.changeCurrency('income');
      this.services.expense = +this.services.expenseRate * +this.services.amount
      this.changeCurrency('expense');
    },




    //autocomplete
    autocompleteResult(data){
      if(this.list.name.mode == 'auto'){
        this.auto[data.input] = data.name
        this.auto[data.input + '_id'] = data.id
      }
      if(this.list.name.mode == 'containers'){
        this.containers[data.input] = data.name
        this.containers[data.input + '_id'] = data.id
        if(data.phone){
          this.containers[data.input + '_phone'] = data.phone
        }
      }
      if(this.list.name.mode == 'services'){
        this.services[data.input] = data.name
        this.services[data.input + '_id'] = data.id
      }
      
    },

    dataInput(data){
      if(this.list.name.mode == 'auto'){
        this.auto[data.input] = data.date
      }
      if(this.list.name.mode == 'containers'){
        this.containers[data.input] = data.date
      }
      if(this.list.name.mode == 'services'){
        this.services[data.input] = data.date
      }
    },

    



    async removeList(){
      if(this.list.name.mode == 'auto') {
        await this.$store.dispatch('carsDelete', this.list.lists[this.list.index].id);
      }
      if(this.list.name.mode == 'containers') {
        await this.$store.dispatch('containersDelete', this.list.lists[this.list.index].id);
      }
      if(this.list.name.mode == 'services') {
        if(this.list.name.modPage == 'quotations'){
          await this.$store.dispatch('servicesDeleteQuotations', this.list.lists[this.list.index].id);
        } else{
          await this.$store.dispatch('servicesDelete', this.list.lists[this.list.index].id);
        }
        
      }

      this.$emit('close', true)
    },


    async save(){
      function boolean(val){
        return (val == false) ? 0 : 1
      }


      //format date
      function date(date){
        if(date){
          var year = date.substr(6, 4);
          var day = date.substr(0,2);
          var month = date.substr(3,2);
          var resultDate = new Date(year + "-" + month + "-" + day).getTime() / 1000;
          return resultDate
        }
      }


      if(this.list.name.mode == 'auto') {
        var data = {
          vin_code: this.auto.vin || '',
          car_manufacture: this.auto.brand_id || '',
          car_model: this.auto.model_id || '',
          release_year: this.auto.year || '',
          date_issue: date(this.auto.dateIssue) || '',
          date_disbandment: date(this.auto.dateDisbandment) || '',
          sum_calc: this.auto.invoiceAmount || '',
          sum_off_payments: this.auto.officialPayments || '',
          order_id: this.list.id || '',
        }
        if(this.list.mod == 'update'){
          data.id = this.list.lists[this.list.index].id
          await this.$store.dispatch('carsUpdate', data);
        } else{
          await this.$store.dispatch('carsAdd', data);
        }
      }

      if(this.list.name.mode == 'containers') {
        var data = {
          number: this.containers.number || '',
          type: this.containers.carType_id || '',
          date1: date(this.containers.exit) || '',
          date2: date(this.containers.return) || '',
          atClient: date(this.containers.atClient) || '',
          fromClient: date(this.containers.fromClient) || '',
          weight: this.containers.weight || '',
          truck_id: this.containers.car_id || '',
          trailer_id: this.containers.trailers_id || '',
          driver_id: this.containers.driver_id || '',
          positionText: this.containers.position || '',
          order_id: this.list.id || '',
        }
        if(this.list.mod == 'update'){
          data.id = this.list.lists[this.list.index].id
          await this.$store.dispatch('containersUpdate', data);
        } else{
          await this.$store.dispatch('containersAdd', data);
        }
      }


      if(this.list.name.mode == 'services') {
        var data = {
          service_id: this.services.name_id || '',
          num: this.services.amount || '',

          rate_in_without_vat: boolean(this.services.isIncomeRateNDS) || '',
          rate: this.services.rateIncome || '',
          vat_income_id: this.services.incomeNDS_id || '',
          sum_income: this.services.income || '',
          currency_income: this.services.incomeCurrency || '',
          exchange_rate_in: this.services.incomeCourse || '',
          sum_income2: this.services.incomeYe || '',
          payment_type_income: this.services.incomePaymentType_id || '',

          rate_outgo: this.services.expenseRate || '',
          rate_out_without_vat: boolean(this.services.isExpenseRateNDS) || '',
          vat_id: this.services.expenseNDS_id || '',
          sum_outgo: this.services.expense || '',
          currency_id: this.services.expenseCurrency || '',
          exchange_rate_out: this.services.expenseCourse || '',
          sum_outgo2: this.services.expenseYe || '',
          payment_type: this.services.expensePaymentType_id || '',

          payment_date: date(this.services.datePayment) || '',
          contractor_id: this.services.provider_id || '',
          comment: this.services.note || '',
          cont_pref: this.services.prefix || '',
          cont_numbers: this.services.number || '',

          
        }
        
        if(this.list.name.modPage == 'quotations'){
          data.quotes_id = this.list.id || ''
          if(this.list.mod == 'update'){
            data.id = this.list.lists[this.list.index].id
            await this.$store.dispatch('servicesUpdateQuotations', data);
          } else{
            await this.$store.dispatch('servicesAddQuotations', data);
          }
        } else{
          data.order_id = this.list.id || ''
          if(this.list.mod == 'update'){
            data.id = this.list.lists[this.list.index].id
            await this.$store.dispatch('servicesUpdate', data);
          } else{
            await this.$store.dispatch('servicesAdd', data);
          }
        }
      }




      this.$emit('close', true)
    },
  },


  components: {
    Autocomplete, DataInput, TheMask
  }
}
</script>